/**
 * 레퍼런스 : https://github.kakaocorp.com/kakaopage/api/blob/58db0cf06dce37e800e5aee64250899a8684fb30/utils/src/main/java/com/kakaopage/utils/model/kakao/CreditStatus.java
 */
export enum CreditStatusVo {
  Charge = 'R01', // 충전
  CancelCharge = 'R02', // 충전취소
  Refund = 'R03', // 환불
  WithdrawEventCash = 'R04', // 기간만료회수
  EventCash = 'R05', // 관리자지급
  WithdrawByAdmin = 'R06', // 관리자회수
  BalanceRefund = 'R07', // 잔액환불
  TransferAccumulation = 'R08', // 이관적립
  TransferDeduction = 'R09', // 이관차감
  CancelChargeRefund = 'R10', // 충전취소(환불)
  ExtinctCash = 'R11', // 캐시소멸
  Exhaust = 'R21', // 소진
  CancelExhaustion = 'R22', // 소진취소
  CancelExhaustedPart = 'R23', // 소진부분취소
  CancelIAPMarket = 'R24', // 스토어부분취소
  WithdrawByAdminPlayPoints = 'R25', // Play Points 캐시 관리자 회수
}
